/**
 * Form handlers for apply and download forms
 */
document.addEventListener("DOMContentLoaded", () => {
	initFormHandlers();
});

/**
 * Form handlers for apply and download forms
 */
function initFormHandlers() {
	const applyForm = document.getElementById('apply-form');
	const downloadForm = document.getElementById('download-form');

	if (applyForm) {
		initForm(applyForm, 'apply');
	}

	if (downloadForm) {
		initForm(downloadForm, 'download');
	}
}

/**
 * Initialize form with confirmation flow
 */
function initForm(form, formType) {
	const inputScreen = document.getElementById('form-input-screen');
	const confirmScreen = document.getElementById('form-confirm-screen');
	const completeScreen = document.getElementById('form-complete-screen');
	const errorDiv = document.getElementById('form-error');
	const errorMessage = document.getElementById('error-message');
	const loadingDiv = document.getElementById('form-loading');

	let formData = {};

	// Form submission (input -> confirm)
	form.addEventListener('submit', (e) => {
		e.preventDefault();

		// Validate
		if (!form.checkValidity()) {
			form.classList.add('was-validated');
			const firstInvalid = form.querySelector(':invalid');
			if (firstInvalid) {
				firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
				firstInvalid.focus({ preventScroll: true });
			}
			return;
		}

		// Collect form data
		formData = collectFormData(form);

		// Show confirmation
		renderConfirmation(formData, formType);
		showScreen(confirmScreen);
		scrollToTop();
	});

	// Back button (confirm -> input)
	const btnBack = document.getElementById('btn-back');
	if (btnBack) {
		btnBack.addEventListener('click', () => {
			showScreen(inputScreen);
			scrollToTop();
		});
	}

	// Submit button (confirm -> submit)
	const btnSubmit = document.getElementById('btn-submit');
	if (btnSubmit) {
		btnSubmit.addEventListener('click', async () => {
			try {
				// Show loading
				loadingDiv.style.display = 'flex';
				if (errorDiv) errorDiv.style.display = 'none';

				// 動作確認用: チェックボックスが ON のとき送信エラーを強制発生
				// （WP_DEBUG 環境でのみ表示されるチェックボックス。本番では存在しない）
				const simulateBox = document.getElementById('_simulate_form_error');
				if (simulateBox && simulateBox.checked) {
					throw new Error('Simulated form submission error (debug)');
				}

				// Submit to GAS
				const result = await submitForm(formType, formData);

				// Hide loading
				loadingDiv.style.display = 'none';

				if (result.success) {
					// Show complete screen
					if (formType === 'download' && result.data.pdfUrl) {
						const downloadLink = document.getElementById('download-link');
						if (downloadLink) {
							downloadLink.href = result.data.pdfUrl;
						}
					}
					showScreen(completeScreen);
					scrollToTop();
				} else {
					// サーバー側エラーでも、入力内容をメールで送れるよう fallback を表示
					showEmailFallback(formData, formType);
				}
			} catch (error) {
				console.error('Form submission error:', error);
				loadingDiv.style.display = 'none';
				// 送信失敗（通信遮断など）。入力内容を保持したままメール送付を案内する
				showEmailFallback(formData, formType);
			}
		});
	}
}

/**
 * Collect form data
 */
function collectFormData(form) {
	const formData = {};
	const elements = form.elements;

	for (let i = 0; i < elements.length; i++) {
		const element = elements[i];
		if (element.name && element.value) {
			// For industry select, save the label text instead of value
			if (element.name === 'industry' && element.tagName === 'SELECT') {
				const selectedOption = element.options[element.selectedIndex];
				formData[element.name] = selectedOption ? selectedOption.text : element.value;
			} else {
				formData[element.name] = element.value;
			}
		}
	}

	return formData;
}

/**
 * Render confirmation screen
 */
function renderConfirmation(data, formType) {
	const confirmContent = document.getElementById('confirm-content');
	if (!confirmContent) return;

	let html = '';

	if (formType === 'apply') {
		html = `
			<div class="confirm-section">
				<h3>企業・団体情報</h3>
				<dl>
					<div class="confirm-row confirm-row--right"><dt>申請日</dt><dd>${escapeHtml(data.applyDate)}</dd></div>
					<div class="confirm-row"><dt>【申請者】企業・団体名 代表者氏名</dt><dd>${escapeHtml(data.companyName).replace(/\n/g, '<br>')}</dd></div>
					<div class="confirm-row"><dt>所在地</dt><dd>${escapeHtml(data.address)}</dd></div>
					<div class="confirm-row"><dt>事業内容</dt><dd>${escapeHtml(data.business)}</dd></div>
					<div class="confirm-row"><dt>業種</dt><dd>${getIndustryLabel(data.industry)}</dd></div>
					<div class="confirm-row"><dt>従業員数（合計）</dt><dd>${escapeHtml(data.employeeCount)}名</dd></div>
					<div class="confirm-row"><dt>従業員数（正規）</dt><dd>${escapeHtml(data.employeeCountRegular)}名</dd></div>
					<div class="confirm-row"><dt>従業員数（非正規）</dt><dd>${escapeHtml(data.employeeCountNonRegular)}名</dd></div>
					<div class="confirm-row"><dt>所属団体</dt><dd>${escapeHtml(data.affiliated)}</dd></div>
					<div class="confirm-row"><dt>ホームページURL</dt><dd>${escapeHtml(data.homepage)}</dd></div>
				</dl>
			</div>
			<div class="confirm-section">
				<h3>受講について</h3>
				<dl>
					<div class="confirm-row"><dt>受講目的</dt><dd>${escapeHtml(data.purpose).replace(/\n/g, '<br>')}</dd></div>
					<div class="confirm-row"><dt>受講予定者数（合計）</dt><dd>${escapeHtml(data.attendanceCount)}名</dd></div>
					<div class="confirm-row"><dt>受講予定者数（正規）</dt><dd>${escapeHtml(data.attendanceCountRegular)}名</dd></div>
					<div class="confirm-row"><dt>受講予定者数（非正規）</dt><dd>${escapeHtml(data.attendanceCountNonRegular)}名</dd></div>
					<div class="confirm-row"><dt>メールドメイン</dt><dd>${escapeHtml(data.domain)}</dd></div>
				</dl>
			</div>
			<div class="confirm-section">
				<h3>担当者情報</h3>
				<dl>
					<div class="confirm-row"><dt>部署/役職</dt><dd>${escapeHtml(data.contactDept)}</dd></div>
					<div class="confirm-row"><dt>氏名</dt><dd>${escapeHtml(data.contactName)}</dd></div>
					<div class="confirm-row"><dt>メールアドレス</dt><dd>${escapeHtml(data.contactEmail)}</dd></div>
				</dl>
			</div>
			<div class="confirm-section">
				<h3>その他</h3>
				<dl>
					<div class="confirm-row"><dt>DREPを知ったきっかけ</dt><dd>${escapeHtml(data.howFound).replace(/\n/g, '<br>')}</dd></div>
				</dl>
			</div>
		`;
	} else if (formType === 'download') {
		html = `
			<div class="confirm-section">
				<dl>
					<div class="confirm-row"><dt>お名前</dt><dd>${escapeHtml(data.name)}</dd></div>
					<div class="confirm-row"><dt>企業・団体名</dt><dd>${escapeHtml(data.companyName)}</dd></div>
					<div class="confirm-row"><dt>業種</dt><dd>${getIndustryLabel(data.industry)}</dd></div>
					${data.contactPerson ? `<div class="confirm-row"><dt>部署・役職</dt><dd>${escapeHtml(data.contactPerson)}</dd></div>` : ''}
					<div class="confirm-row"><dt>メールアドレス</dt><dd>${escapeHtml(data.email)}</dd></div>
					<div class="confirm-row"><dt>電話番号</dt><dd>${escapeHtml(data.phone)}</dd></div>
					<div class="confirm-row"><dt>従業員数</dt><dd>${getEmployeeCountLabel(data.employeeCount)}</dd></div>
				</dl>
			</div>
		`;
	}

	confirmContent.innerHTML = html;
}

/**
 * Submit form to GAS
 */
async function submitForm(formType, data) {
	const config = window.DREP_FORM_CONFIG || {};
	const gasUrl = config.gas_url || window.DREP_GAS_URL;
	if (!gasUrl) {
		throw new Error('GAS URL not configured');
	}

	const response = await fetch(gasUrl, {
		method: 'POST',
		headers: {
			'Content-Type': 'text/plain' // Avoid CORS preflight
		},
		body: JSON.stringify({
			formType: formType,
			origin: window.location.origin,
			data: data
		})
	});

	if (!response.ok) {
		throw new Error(`HTTP error: ${response.status}`);
	}

	return await response.json();
}

/**
 * Show screen
 */
function showScreen(screen) {
	document.querySelectorAll('.form-screen').forEach(s => s.classList.remove('active'));
	screen.classList.add('active');
}

/**
 * Scroll to top
 */
function scrollToTop() {
	window.scrollTo({ top: 0, behavior: 'smooth' });
}

/**
 * Escape HTML
 */
function escapeHtml(text) {
	const div = document.createElement('div');
	div.textContent = text;
	return div.innerHTML;
}

/**
 * Get industry label from value
 * Since we're now sending the label text directly, just return as-is
 */
function getIndustryLabel(value) {
	// Value is already the label text (e.g., "1 自動車(2輪車等も含む)")
	return escapeHtml(value);
}

/**
 * Get employee count label from code
 */
function getEmployeeCountLabel(code) {
	const labels = {
		'1000': '1,000人以上',
		'999': '100〜999人',
		'99': '10〜99人',
		'9': '9人以下'
	};
	return labels[code] || code;
}

/**
 * Indent a (possibly multi-line) value for the plain-text email body
 */
function indentValue(text) {
	if (!text) return '  （未入力）';
	return String(text).split('\n').map(line => '  ' + line).join('\n');
}

/**
 * Build a paste-ready plain-text representation of the form input,
 * used when the user must email their submission (send-failure fallback).
 * Mirrors the confirmation screen structure.
 */
function buildEmailBody(data, formType) {
	const sep = '==================================================';
	const lines = [];

	if (formType === 'apply') {
		lines.push(sep);
		lines.push('DREP 受講申し込み（メール送信）');
		lines.push(sep);
		lines.push('');
		lines.push('Webフォームからの送信ができなかったため、入力内容を下記に記載しています。');
		lines.push('このまま事務局宛にメールでお送りください。');
		lines.push('');
		lines.push('--- 企業・団体情報 ---');
		lines.push('申請日: ' + (data.applyDate || ''));
		lines.push('【申請者】企業・団体名 代表者氏名:');
		lines.push(indentValue(data.companyName));
		lines.push('所在地: ' + (data.address || ''));
		lines.push('事業内容: ' + (data.business || ''));
		lines.push('業種: ' + (data.industry || ''));
		lines.push('従業員数: ' + (data.employeeCount || '') + ' 名（正規 ' + (data.employeeCountRegular || '') + ' / 非正規 ' + (data.employeeCountNonRegular || '') + '）');
		lines.push('所属団体: ' + (data.affiliated || ''));
		lines.push('ホームページURL: ' + (data.homepage || ''));
		lines.push('');
		lines.push('--- 受講について ---');
		lines.push('受講目的:');
		lines.push(indentValue(data.purpose));
		lines.push('受講予定者数: ' + (data.attendanceCount || '') + ' 名（正規 ' + (data.attendanceCountRegular || '') + ' / 非正規 ' + (data.attendanceCountNonRegular || '') + '）');
		lines.push('メールドメイン: ' + (data.domain || ''));
		lines.push('');
		lines.push('--- 担当者情報 ---');
		lines.push('部署/役職: ' + (data.contactDept || ''));
		lines.push('氏名: ' + (data.contactName || ''));
		lines.push('メールアドレス: ' + (data.contactEmail || ''));
		lines.push('');
		lines.push('--- その他 ---');
		lines.push('DREPを知ったきっかけ:');
		lines.push(indentValue(data.howFound));
		lines.push('');
		lines.push(sep);
	} else if (formType === 'download') {
		lines.push(sep);
		lines.push('DREP 資料ダウンロード申し込み（メール送信）');
		lines.push(sep);
		lines.push('');
		lines.push('Webフォームからの送信ができなかったため、入力内容を下記に記載しています。');
		lines.push('このまま事務局宛にメールでお送りください。');
		lines.push('');
		lines.push('お名前: ' + (data.name || ''));
		lines.push('企業・団体名: ' + (data.companyName || ''));
		lines.push('業種: ' + (data.industry || ''));
		if (data.contactPerson) {
			lines.push('部署・役職: ' + data.contactPerson);
		}
		lines.push('メールアドレス: ' + (data.email || ''));
		lines.push('電話番号: ' + (data.phone || ''));
		lines.push('従業員数: ' + getEmployeeCountLabel(data.employeeCount || ''));
		lines.push('');
		lines.push(sep);
	}

	return lines.join('\n');
}

/**
 * Populate and open the send-failure fallback modal:
 * shows the office email + a paste-ready copy of the input so the user
 * can email their submission without re-typing it.
 */
function showEmailFallback(formData, formType) {
	const modal = document.getElementById('email-fallback-modal');
	if (!modal) {
		// Fallback of the fallback: no modal markup on the page
		alert('送信に失敗しました。お手数ですが事務局までメールでお問い合わせください。');
		return;
	}

	const config = window.DREP_FORM_CONFIG || {};
	const officeEmail = config.office_email || '';
	const emailBody = buildEmailBody(formData, formType);
	const subject = formType === 'download'
		? '【DREP】資料ダウンロード申し込み（フォーム送信エラー）'
		: '【DREP】受講申し込み（フォーム送信エラー）';
	const mailto = 'mailto:' + officeEmail + '?subject=' + encodeURIComponent(subject);

	// Paste-ready text
	const textarea = modal.querySelector('#email-fallback-textarea');
	if (textarea) textarea.value = emailBody;

	// Office email address + mailto links
	const addr = modal.querySelector('#email-fallback-mailto');
	if (addr) {
		addr.textContent = officeEmail;
		addr.href = mailto;
	}
	const mailtoBtn = modal.querySelector('#email-fallback-mailto-btn');
	if (mailtoBtn) mailtoBtn.href = mailto;

	// Copy button (clone-replace to drop any listener from a previous open)
	const copyBtn = modal.querySelector('.btn-copy-email-body');
	const feedback = modal.querySelector('.copy-feedback');
	if (copyBtn) {
		const freshBtn = copyBtn.cloneNode(true);
		copyBtn.replaceWith(freshBtn);
		freshBtn.addEventListener('click', async () => {
			try {
				await navigator.clipboard.writeText(emailBody);
				if (feedback) {
					feedback.textContent = ' コピーしました';
					setTimeout(() => { feedback.textContent = ''; }, 2000);
				}
			} catch (e) {
				if (textarea) {
					textarea.focus();
					textarea.select();
				}
				if (feedback) {
					feedback.textContent = ' 自動コピーに失敗しました。Ctrl+C / ⌘+C でコピーしてください。';
				}
			}
		});
	}

	// Open via Bootstrap's data-API (hidden trigger button), so we don't depend
	// on a global `bootstrap` object (it isn't exposed by the app bundle).
	const trigger = document.getElementById('email-fallback-trigger');
	if (trigger) {
		trigger.click();
	}
}
